import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * API handler to add a new order using centralized API utility.
 *
 * @param {Object} order - Order details object
 * @returns {Promise<Object>} - Created order response from the backend
 * @throws Will throw an error if the request fails
 * 
 * @author Susovan Mishra
 */
const createOrder = async (order) => {
  return await apiCall(AUTH_ROUTES.ORDER_API_ENDPOINT, {
    method: "POST",
    body: order,
  });
};

export default createOrder;
